import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface SendSlipResult {
  success: boolean;
  error?: string;
}

export function useSendSlipEmail() {
  const [isSending, setIsSending] = useState(false);

  const sendSlipEmail = async (salaryId: string, email?: string): Promise<SendSlipResult> => {
    setIsSending(true);
    try {
      const { error } = await supabase.functions.invoke('send-slip-to-email', {
        body: { salaryId, type: "fs-teacher", email }
      });

      if (error) {
        console.error('Send slip email error:', error);
        toast.error('ไม่สามารถส่งอีเมลได้: ' + error.message);
        return { success: false, error: error.message };
      }

      toast.success('ส่งอีเมลเรียบร้อยแล้ว');
      return { success: true };
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unknown error';
      console.error('Send slip email exception:', err);
      toast.error('เกิดข้อผิดพลาด: ' + message);
      return { success: false, error: message };
    } finally {
      setIsSending(false);
    }
  };

  return { sendSlipEmail, isSending };
}
